import { Box, Typography, TypographyProps } from '@mui/material';
import { ReactNode, useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { appConfig } from 'src/config';
import { PageContext } from 'src/contexts/page-context';

interface Props {
  title: string;
  children?: ReactNode;
  additionalTitleSlot?: ReactNode;
  belowTitleSlot?: ReactNode;
  headerVariant?: TypographyProps['variant'];
}

const PageHeader = ({
  title,
  children,
  additionalTitleSlot,
  belowTitleSlot,
  headerVariant = 'h4',
}: Props) => {
  const { setTitle } = useContext(PageContext);

  useEffect(() => {
    if (title) {
      setTitle(title);
    }
  }, [title]);

  return (
    <Box sx={{ py: 4 }}>
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
        }}>
        {title ? (
          <>
            <Helmet>
              <title>
                {title} | {appConfig.name}
              </title>
            </Helmet>

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
              }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: 2,
                }}>
                <Typography color="textPrimary" variant={headerVariant}>
                  {title}
                </Typography>
                {additionalTitleSlot}
              </Box>
              {belowTitleSlot}
            </Box>
            <Box sx={{ flexGrow: 1 }} />
          </>
        ) : null}
        {children}
      </Box>
    </Box>
  );
};

export default PageHeader;
